<template>
  <div>
    <div id="body">
      <div class="wrapper">
        <div class="usercenter">
          <UserLeftGuid :menuActive="'/user/order'"></UserLeftGuid>

          <div class="main">
            <div class="title">
              <h2>
                <svg viewBox="0 0 1024 1024"
                     xmlns="http://www.w3.org/2000/svg"
                     data-v-78e17ca8="">
                  <path fill="currentColor"
                        d="M704 192h160v736H160V192h160v64h384v-64zM288 512h448v-64H288v64zm0 256h448v-64H288v64zm96-576V96h256v96H384z"></path>
                </svg>
                我的订单
              </h2>
            </div>
            <div class="box">
              <div class="list-top">
                <!-- <div class="list-page-total">
                  共 {{ total }} 条 第{{ pageIndex }}/{{ pageCount }}页
                </div> -->
                <el-tabs v-model="activeName"
                         @tab-click="handleTabClick">
                  <el-tab-pane label="VIP订单"
                               name="1"></el-tab-pane>
                  <el-tab-pane label="积分充值"
                               name="2"></el-tab-pane>
                </el-tabs>
              </div>

              <div class="box-content"
                   v-loading="loading">
                <el-table :data="tableData"
                          style="width: 100%">
                  <el-table-column align="center"
                                   label="序号"
                                   type="index"
                                   width="80"
                                   :index="handleTableIndex">
                  </el-table-column>
                  <el-table-column align="center"
                                   label="订单号"
                                   min-width=""
                                   prop="orderNumber">
                  </el-table-column>
                  <el-table-column align="center"
                                   label="商品名"
                                   min-width=""
                                   prop="name"
                                   width="100">
                    <template #default="scope">
                      {{ activeName === "1" ? scope.row.name : "积分充值" }}
                    </template>
                  </el-table-column>
                  <el-table-column align="center"
                                   label="支付方式"
                                   min-width=""
                                   prop="payMethod"
                                   width="80">
                  </el-table-column>
                  <el-table-column align="center"
                                   label="支付金额"
                                   min-width=""
                                   prop="payMoney"
                                   width="80">
                  </el-table-column>
                  <el-table-column align="center"
                                   label="支付状态"
                                   width="80">
                    <template #default="scope">
                      {{
                        scope.row.payStatus === 1
                          ? "支付成功"
                          : scope.row.payStatus === 2
                          ? "支付失败"
                          : "未支付"
                      }}
                    </template>
                  </el-table-column>

                  <el-table-column align="center"
                                   label="下单时间"
                                   width="160">
                    <template #default="scope">
                      {{ dateFormat(scope.row.orderTime) }}
                    </template>
                  </el-table-column>
                  <!-- <el-table-column align="center" label="操作" width="250">
                    <template #default="scope">
                      <el-button
                        type="text"
                        size="mini"
                        icon="el-icon-view"
                        @click="handleView(scope.row.dataId, scope.row.lngid)"
                        >查看
                      </el-button>
                    </template>
                  </el-table-column> -->
                </el-table>
                <div class="list-bottom">
                  <div class="list-page-total">
                    共 {{ total }} 条 第{{ pageIndex }}/{{ pageCount }}页
                  </div>
                  <div class="list-page">
                    <el-pagination :current-page="pageIndex"
                                   :page-size="pageSize"
                                   layout="prev,pager,next,jumper"
                                   :total="total"
                                   @current-change="handleCurrentPageChange">
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserLeftGuid from "../../components/user/left_guid.vue";
import { axiosRequest, axiosOptions } from "../../util/request";
import moment from "moment";

export default {
  components: { UserLeftGuid },
  data () {
    return {
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      pageCount: 0,
      total: 0,
      loading: false,
      activeName: "1",
    };
  },
  mounted () {
    this.getList();
  },
  methods: {
    handleTabClick (tab) {
      this.pageIndex = 1;
      switch (this.activeName) {
        case "1":
          this.getList();
          break;
        case "2":
          this.getIntegralOrderList();
          break;
      }
    },
    handleTableIndex (index) {
      return ((this.pageIndex || 1) - 1) * (this.pageSize || 10) + index + 1;
    },
    dateFormat (cellValue, type) {
      if (!cellValue) return "";
      if (type === "date") {
        return moment(cellValue).format("YYYY-MM-DD");
      }
      return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
    },
    getList () {
      this.loading = true;

      axiosRequest(
        "/user/order-list",
        {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.total = res.data.data.total;
            this.pageCount = res.data.data.pages;
            this.tableData = res.data.data.records;
          }

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getIntegralOrderList () {
      this.loading = true;

      axiosRequest(
        "/user/integral-order-list",
        {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.total = res.data.data.total;
            this.pageCount = res.data.data.pages;
            this.tableData = res.data.data.records;
          }

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleCurrentPageChange (currentPage) {
      this.pageIndex = currentPage;
      switch (this.activeName) {
        case "1":
          this.getList();
          break;
        case "2":
          this.getIntegralOrderList();
          break;
      }
    },
    handleSearch () {
      this.pageIndex = 1;
      this.getList();
    },
    handleView (type, id) {
      //console.log(type + id);
      let routerName = "";
      if (type === 0) {
        routerName = "report_list";
      } else if (type === 1) {
        routerName = "qingbao_list";
      }
      if (id) {
        this.$router.push({ name: routerName, params: { id: id } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "~@/assets/css/usercenter.scss";
</style>
